import React, { Component } from "react";
import "./PopularOffersItem.css";

class PopularOffersItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { offer } = this.props;

    const { url, image, isOpenInNewWindow, alt } = offer;

    return (
      <div className="popular-offers-item-link-container">
        <a
          className="popular-offers-item-link"
          href={url}
          target={isOpenInNewWindow ? "_blank" : "_self"}
        >
          <div className="popular-offers-item-container">
            <img
              className="popular-offers-img img-responsive"
              src={image}
              alt={alt}
              loading="lazy"
            />
          </div>
        </a>
      </div>
    );
  }
}

export default PopularOffersItem;
